<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout wrap>
                      <div class="flex md12">

                        <div>
                          <v-text-field :label="$t('Department-Code-Bolum')" :color="color" v-model="Bolum.SectionCode"
                            :error-messages="errors.collect('sirketkod')" v-validate="'required'"
                            data-vv-name="sirketkod" required>
                          </v-text-field>
                        </div>

                        <v-text-field :label="$t('Section-Name')" :color="color" v-model="Bolum.SectionName"
                          :error-messages="errors.collect('sirketadi')" v-validate="'required'" data-vv-name="sirketadi"
                          required>
                        </v-text-field>



                        <v-text-field :label="$t('Section-External-Code')" :color="color" v-model="Bolum.SectionOuterCode">
                        </v-text-field>
                      </div>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">



              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Delete" color="info" slot="activator" @click="deletebolum()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Delete') }} </span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Delete"> {{ $t('Delete') }} </span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="guncelle()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>


            </div>

            <v-btn color="blue darken-1" flat @click="vazgec()">{{$t('Cancel')}}</v-btn>
            <div v-show="k === true">

 <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="Kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>



            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>


      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>{{$t('Department-Code-Bolum')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3"  :label="this.$t('Search')" append-icon="search">
        </v-text-field>

<v-tooltip bottom>
          <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="bolumekle()" flat> <span
              class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Add-v2', { value: $t('Department')}) }} </span>
            </span>
            <v-icon right dark>add_box</v-icon>

          </v-btn>
          <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
          <span v-if="sayfayetki.Save">{{ $t('Add-v2', { value: $t('Department')}) }}</span>
        </v-tooltip>




      </v-toolbar>


    </v-layout>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
        :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item)" item>
            <td class="text-xs-left">{{ props.item.BolumKodu }}</td>
            <td class="text-xs-left">{{ props.item.BolumAdi }}</td>
            <td class="text-xs-left">{{ props.item.BolumDisKodu }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           {{ $t('No-records-searched-for', { value: search3}) }} 
        </v-alert>
      </v-data-table>
    </v-card>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        headers: [{
            text: this.$t('Department-Code-Bolum'),
            value: 'BolumKodu'
          },
          {
            text: this.$t('Section-Name'),
            value: 'BolumAdi'
          },
          {
            text: this.$t('Section-External-Code'),
            value: 'BolumDisKodu'
          }


        ],
        loading: false,
        color: 'orange darken-4',
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        Bolum: {

          CompanyCode: '',
          SectionCode: '',
          SectionName: '',
          SectionOuterCode: ''

        },
        state: [],
        progress: false,
        dialog_baslik: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        bankakod: '',
        bankaadi: '',
        dictionary: {
          custom: {
            sirketkod: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            sirketadi: {
              required: () => this.$t('This-space-cannot-left-blank'),
            }
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        this.progress = true
        var credentials1 = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          CompanyCode: credentials1.SirketKodu
        }

        this.$http.post(auth.API_URL + 'api/Definitions/SectionList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.progress = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    methods: {
      Getir(v) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.Bolum.SectionCode = v.BolumKodu
        this.Bolum.SectionName = v.BolumAdi
        this.Bolum.SectionOuterCode = v.BolumDisKodu



        this.k = false
        this.m = true
        this.$validator.reset()


        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Bölüm Güncelle'


      },
      deletebolum: deletebolum,
      bolumekle: bolumekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog
    },
    vazgec: vazgec
  }


  function vazgec() {
    this.dialog = false
  }



  function Kaydet() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.$validator.validateAll().then((result) => {
      if (result) {

        var params = {
          CompanyCode: credentials.SirketKodu,
          SectionCode: this.Bolum.SectionCode,
          SectionName: this.Bolum.SectionName,
          SectionOuterCode: this.Bolum.SectionOuterCode
        }
        this.$http.post(auth.API_URL + 'api/Definitions/SectionAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true
          this.dialog = false


          var params1 = {
            CompanyCode: credentials.SirketKodu
          }
          this.$http.post(auth.API_URL + 'api/Definitions/SectionList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable.'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable.'
              this.snackbar = true
            }
          })
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable.'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable.'
            this.snackbar = true
          }
        })
      }


    })

  }

  function bolumekle() {

    this.dialog = true
    this.Sirket = {}
    this.dialog_baslik = 'Bölüm Ekle'



    this.Bolum.SectionCode = null
    this.Bolum.SectionName = null
    this.Bolum.SectionOuterCode = null
    this.m = false
    this.k = true
    this.codegorunum = true
    this.$validator.reset()

  }

  function beforeMount() {

  }

  function deletebolum() {



    if (window.confirm('Bölüm\'ü silmek istediğinizden eminmisiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      this.Bolum.CompanyCode = credentials.SirketKodu

      var params = this.Bolum
      this.$http.post(auth.API_URL + 'api/Definitions/SectionDelete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true

          var credentials1 = JSON.parse(window.localStorage.getItem('credentials'));
          var params1 = {
            CompanyCode: credentials1.SirketKodu
          }

          this.$http.post(auth.API_URL + 'api/Definitions/SectionList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.dialog = false

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {
      if (result) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.Bolum.CompanyCode = credentials.SirketKodu
        var params = this.Bolum


        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/Definitions/SectionUpdate', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true



            var params1 = {
              CompanyCode: credentials.SirketKodu
            }

            this.$http.post(auth.API_URL + 'api/Definitions/SectionList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>